module.exports = __webpack_public_path__ + "static/media/animals.58bd96d0.mov";